<script lang="typescript">
  import { useMachine } from '@xstate/svelte';
  import type { ClientMeetingInfo } from '../../common/types';
  import { createMachine } from './machine';
  import JitsiVideoMeeting from '../jitsi/JitsiVideoMeeting.svelte';
  export let clientMeetingInfo:ClientMeetingInfo;
  const machine = createMachine(clientMeetingInfo);
  const { state, send } = useMachine(machine);
  const joined = () => {
    send({type: 'JOIN'});
  };
  const left = () => {
    send({type: 'LEAVE'});
  };
  $: jwt = $state.context.meetingInfo.jwt;
  $: roomName = $state.context.meetingInfo.jaas_room_name;
  $: videoVisible = 
    [ 'not_started.not_joined'
    , 'not_started.notifying_join'
    , 'started.not_joined'
    , 'started.joined' ].some($state.matches);
  $: notifyingJoin = $state.matches('not_started.notifying_join');
  $: couldNotNotifyStart = $state.matches('not_started.error_notifying');
  $: showRejoin = [ 'started.hangup', 'started.error_notifying' ].some($state.matches);
  $: showFinishButton = 
    [ 'started.not_joined', 'started.hangup', 'started.error_notifying' ].some($state.matches);
  $: showFinishLoadingIndicator = $state.matches('started.notifying_finish');
  $: meetingFinished = $state.matches('finished');
  $: meetingCancelled = $state.matches('cancelled');
  $: couldNotNotifyFinish = $state.matches('started.error_notifying');
</script>

<main>
  {#if couldNotNotifyStart}
    <div class="error">
      <p>Nemonettiin ei pystytty lähettämään tietoa tapaamisen alkamisesta. Yritä
      hetken kuluttua liittyä uudelleen tapaamiseen.</p>
      <p>
      <button on:click={() => send({type: 'JOIN'})}>Liity uudelleen</button>
      </p>
    </div>
  {/if}

  {#if couldNotNotifyFinish}
    <div class="error">
      <p>Nemonettiin ei pystytty lähettämään tietoa tapaamisen loppumisesta. Yritä hetken kuluttua lähetää päättymistieto uudelleen.</p>
    </div>
  {/if}

  {#if showFinishButton}
    <p>
    <button on:click={() => send({type: 'FINISH'})}>Päätä tapaaminen</button>
    </p>
  {/if}

  {#if showFinishLoadingIndicator}
    <p>
    <i class="fas fa-spinner fa-spin"></i>
    Lähetetään tieto tapaamisen päättymisestä Nemonettiin...
    </p>
  {/if}

  {#if meetingFinished}
    <p>Tapaaminen on päättynyt.</p>
  {/if}

  {#if meetingCancelled}
    <p>Tapaaminen peruttu.</p>
  {/if}

  {#if videoVisible}
    <JitsiVideoMeeting {jwt} {roomName} on:join={joined} on:leave={left} />
  {/if}

  {#if notifyingJoin}
    <p>
    <i class="fas fa-spinner fa-spin"></i>
    Lähetetään tieto tapaamisen alkamisesta Nemonettiin...
    </p>
  {/if}

  {#if showRejoin}
    <p>
    <button on:click={() => send({ type: 'JOIN' })}>Liity uudelleen tapaamiseen</button>
    </p>
  {/if}
</main>
